module.exports = __webpack_public_path__ + "media/images/common/ico-crown-outline-c0cbf53d6f285398b5f394d4665f8b20.svg";